import { useGetMyProfileQuery } from "@/features/dashboard/api/dashboardApi";
import { ErrorState } from "@/shared/components/ErrorState";
import { Card, Group, Skeleton, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FiBriefcase } from "react-icons/fi";

export function MyOrganizationsWidget() {
  const { t } = useTranslation("dashboard");
  const { data: profile, isLoading, error, refetch } = useGetMyProfileQuery();

  return (
    <Card withBorder padding="lg" h="100%">
      <Stack gap="sm">
        <Group gap="xs">
          <FiBriefcase aria-hidden="true" />
          <Title order={4}>{t("widgets.organizations.title")}</Title>
        </Group>

        {isLoading ? (
          <Stack gap="xs">
            <Skeleton height={12} width="70%" />
            <Skeleton height={12} width="55%" />
          </Stack>
        ) : error || !profile ? (
          <ErrorState message={t("widgets.organizations.error")} onRetry={() => void refetch()} />
        ) : profile.orgMemberships.length === 0 ? (
          <Text size="sm" c="dimmed">
            {t("widgets.organizations.empty")}
          </Text>
        ) : (
          <Stack gap="xs">
            {profile.orgMemberships.map((m) => (
              <Text key={m.orgId} size="sm">
                {m.orgName}
              </Text>
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
